<!--
 * @Author: Merlin
 * @Date: 2025-08-08 14:58:04
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-19 17:01:41
 * @Description: 
-->
<template>
    <div 
        ref="playWrapRef"
        class="play-wrap"
        :class="[
            seatClass,
            {
                'at-right': !!atRight, 
                'user-self': !!userInfo.isSelf, 
                'now-pking': gamersInPk?.includes(gamerID), 
                'select-user': isSelect,
            }
        ]"
    > 
    <template v-if="userInfo.id">
        <div class="user-info relative" @click="selectUser">
                <img v-show='!userInfo.isSelf' src="../img/pointer.webp" class="pointer-img">
                <div v-if="msgInfo.key && msgInfo.key !== 'Val' " class="msg" :class="`msg-${msgInfo.tag}`">
                    {{ $t(`goldenFlower.${msgInfo.key}`, { val: msgInfo.val }) }}
                    <i class="tri-down"></i>
                </div>
                <!-- 结算金额 -->
                <Transition name="bounce">
                    <div v-if="msgInfo.key === 'Val'" class="settled-text" :class="{won: Number(msgInfo.val) > 0}">
                        {{ Number(msgInfo.val) > 0 ? '+' : '' }}
                        {{ msgInfo.val }}
                    </div>
                </Transition>
                <UserAvatar
                    :class="{ active: !userInfo.isSelf, lose: userInfo.isLose || userInfo.isQuit }"
                    :size="'var(--avatar-size)'"
                    :src="userInfo.avatar"
                />
                <NameTag 
                    class="name-tag"
                    :userName="userInfo.name" 
                    :balance="userInfo.chips"
                    :countingDown="roundTime"
                    :isBanker="isBanker"
                    :lv="userInfo.lvl"
                    :showProgress="showProgress"
                    :atRight="atRight"
                />
        </div>
        <!-- 左右分界 --> 
        <div class="cards-info">
            <div class="cards-wrap flex" ref="cardsWrapRef">
                <!-- <div v-if="roundTime >= 0 && showProgress" class="clock"> -->
                <div v-if="roundTime >= 0 && showProgress" class="clock-box">
                    <img :class="{ clock: true, 'clock-shake': roundTime >= 0 && roundTime <= 3 }" src="../img/clock.webp"
                        alt="">
                    <span class="clock-num">{{ roundTime }}</span>
                </div>
                <CardType v-if='userInfo.isWatchCards || userInfo.isShowCard' :isSelf="userInfo.isSelf" :type="userInfo.cardType" />
                <!-- 看牌标识 -->
                <div v-if="!userInfo.isSelf && userInfo.isWatchCards &&!userInfo.isShowCard" class="status-tag bg-slate-700" :class="{ 'tag-other' : !userInfo.isSelf }">{{$t('goldenFlower.Viewed')}}</div>
                <button v-if="showBtn" class="status-tag view-btn" @click="viewCard">{{$t('goldenFlower.View')}}</button>

                <pokerCard
                    v-for="i01 in 3"
                    :key="i01"
                    :width="`${iCardWidth}px`"
                    class="opacity-0"
                />
                <!-- ↑ 纯占位，不可见 --> 
                <!-- ↓ 真的牌，可见 --> 
                <div class="real-cards flex"
                    v-show="aLocalCards.length" 
                >
                    <TransitionGroup>
                        <pokerCard
                            v-for="(it, index) in aLocalCards"
                            :key="index"
                            :cardName="getCardName(it.suit, it.rank)"
                            :width="`${iCardWidth}px`"
                            real
                            :ref="el => cardRefs[index] = el"
                        />
                    </TransitionGroup>
                </div>
                
                <div v-if="gameWinner && showResult" class="result-pics">
                    <Transition name="bounce">
                        <img :src="oResultPic.win" 
                            v-if="gameWinner.includes(gamerID)"
                        />
                        <img :src="oResultPic.fail" 
                            v-else-if="gamersInPk.includes(gamerID)"
                        />
                    </Transition>
                </div>
            </div>
            <!-- 
                ↑ 发牌后显示牌 
                ↓ 开局后显示金额 
            -->
            <div class="h-[18px]">
                <wagerAmount
                    v-show="userInfo.inGame || userInfo.cards?.length" 
                    ref="wagerRef"
                    :wagerValue="userInfo.totalBet"
                    :atRight="!!atRight"
                />
            </div>
        </div>
    </template>
        <!--
            分界
        -->
        <div v-else
            class="empty-figure"
        >
            <span class="empty-avatar">
                {{ $t('goldenFlower.empty') }}
            </span>
        </div>
    </div>
</template>

<script lang="ts" setup> 
import NameTag from './nameTag.vue'; 
import wagerAmount from './wagerAmount.vue'; 
import pokerCard from './pokerCard.vue'; 
import CardType from './cardType.vue'
import { useUserStore } from '~/stores/user';
import winCn from '../img/win-cn.webp'; 
import winEn from '../img/win-en.webp'; 
import failCn from '../img/fail-cn.webp'; 
import failEn from '../img/fail-en.webp'; 
import type { Player, ActionMsg } from '../ts/types';
import { getDealerRect, playDealAnimation as playDealAnimationFn } from '../ts/animation';
import { Sleep } from '~/utils/promise';
import { playMusic } from '../ts/music';

const props = withDefaults(defineProps<{
    atRight?: boolean,
    userInfo: Player,
    gamerID?: string, // '1' | '2' | '3' | '4' | '5'
    seatIndex?: number, // 用于确定从庄家发牌的大致方向（1~5）
    gameWinner?: string, // '1' | '2' | '3' | '4' | '5'
    gamersInPk?: string,  // 12, 13, 25, 34,
    isSelect?: boolean,
    roundTime?: number,
    isBanker?: boolean,
    msgInfo?: ActionMsg,
    showProgress?: boolean,
    showResult?: boolean
    isCompaire?: boolean
}>(), {
    userInfo: () => ({} as Player),
    msgInfo: () => ({} as ActionMsg)
});
const emits = defineEmits<
    {
        viewCard: [],
        selectUser: [val:any],
    }
>();
const wagerRef = ref();
const cardsWrapRef = ref();
const playWrapRef = ref();
const $i18n = useNuxtApp().$i18n;
const aLocalCards = ref([]);
const cardRefs = ref<any[]>([]);
let insertGeneration = 0;

// 根据座位号给不同玩家一个 class，用于控制发牌方向
const seatClass = computed(() => {
    return props.seatIndex ? `seat-${props.seatIndex}` : '';
});

const iCardWidth = computed(()=>{
    return props.userInfo.isSelf ? 56 : 34;
});
const sLang = computed(()=>{
    return $i18n.locale.value;
});
const showBtn = computed(() => props.userInfo.isSelf && aLocalCards.value.length && !props.userInfo.isWatchCards && !props.isCompaire)

const fnInsert = async (aNew) => {
    if (!import.meta.client) return;
    const gen = ++insertGeneration;
    console.log('fnInsert', aNew, 'gen:', gen);
    
    // 清空现有牌
    aLocalCards.value.splice(0, 1/0);
    await nextTick();
    if (gen !== insertGeneration) return;
    
    // 提前获取庄家位置（只获取一次，避免循环中重复查询 DOM）
    const dealerRect = getDealerRect();
    if (!dealerRect) {
        aLocalCards.value = aNew;
        return;
    }
    
    // 依次添加每张牌并执行动画
    for (const oOneCard of aNew) {
        if (gen !== insertGeneration) return;
        aLocalCards.value.push(oOneCard);
        await nextTick();
        if (gen !== insertGeneration) return;
        // 针对最新插入的这张牌执行"从庄家飞来"的动画
        const idx = aLocalCards.value.length - 1;
        const cardComp = cardRefs.value[idx];
        if (cardComp && dealerRect) {
            playDealAnimationFn(idx, dealerRect, cardComp);
        }
        await Sleep(125);
    }
};

const insertCoin = ()=>{
    if (!wagerRef.value?.fnInsert) return;
    wagerRef.value.fnInsert();
    playMusic('chips');
}

const getCardName = (suit = '', rank = '') => suit + rank;

// 看牌
const viewCard = () =>{
    emits('viewCard');
}


const oResultPic = computed(()=>{
    if (sLang.value == 'cn'){
        return {
            win: winCn,
            fail: failCn,
        }
    }
    return {
        win: winEn,
        fail: failEn,
    }; 
}); 

const selectUser = () => {
    if (props.userInfo.isSelf || !props.isSelect) return;
    emits('selectUser', props.userInfo);
}

const playShowCards = () => {
    cardRefs.value.forEach(card => {
        card?.playHighlightEffect();
    });
}

// 获取当前玩家下注筹码区域的 DOM 位置信息，用于结算时飞筹码动画
const getWagerRect = () => {
    const el = (wagerRef.value as any)?.$el as HTMLElement | undefined;
    if (!el) return null;
    // 获取筹码图片的位置（.coin-box 内的第一个 img 标签）
    const coinBox = el.querySelector('.coin-box') as HTMLElement | null;
    const chipImg = coinBox?.querySelector('img') as HTMLElement | null;
    return chipImg?.getBoundingClientRect() || coinBox?.getBoundingClientRect() || el.getBoundingClientRect();
}

// 获取当前玩家头像区域的 DOM 位置信息，用于结算时飞筹码动画
const getAvatarRect = () => {
    const playWrapEl = playWrapRef.value as HTMLElement | undefined;
    if (!playWrapEl) return null;
    const userInfoEl = playWrapEl.querySelector('.user-info') as HTMLElement | null;
    if (!userInfoEl) return null;
    // 获取头像元素（UserAvatar 组件渲染的 .user-avatar 元素）
    const avatarEl = userInfoEl.querySelector('.user-avatar') as HTMLElement | null;
    return avatarEl?.getBoundingClientRect() || userInfoEl.getBoundingClientRect();
}

watch(
    () => props.userInfo.cards,
    (aNew, aOld)=>{
        console.log(`用户 ${props.gamerID} 的牌: `, deepCopy(aNew)); 
        if (!aNew?.length){
            insertGeneration++;
            aLocalCards.value.splice(0, 1/0); 
        }else if(aNew.length > (aOld?.length || 0)){
            const isPlayerInGame = props.userInfo.inGame && !props.userInfo.isQuit && !props.userInfo.isLose;
            const isEmptyPlaceholder = aNew.length === 3 && aNew.every(card => !card.suit && !card.rank);
            if (isPlayerInGame || !isEmptyPlaceholder) {
                fnInsert(aNew);
            } else {
                insertGeneration++;
                aLocalCards.value = aNew;
            }
        } else {
            insertGeneration++;
            aLocalCards.value = aNew;
        }
    },
);

defineExpose({
    insertCoin,
    playShowCards,
    getWagerRect,
    getAvatarRect,
})
</script>

<style lang="scss" scoped>
.play-wrap{
    display: flex;
    justify-content: flex-start; 
    align-items: center; 
    --avatar-size: 50px;
}


.empty-figure{
    width: var(--avatar-size);
    height: var(--avatar-size);
    display: flex;
    justify-content: center; 
    align-items: center; 
    .empty-avatar{
        width: 40px;
        height: 40px; 
        background: rgba(45, 45, 45, 0.77);
        border: 1px solid rgba(0, 0, 0, 1);
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
        border-radius: 100px; 
        text-align: center; 
        font-weight: 400;
        font-size: 10px;
        text-align: center;
        vertical-align: middle;
        display: flex;
        justify-content: center; 
        align-items: center; 
        color: rgba(255, 255, 255, 0.5);
    }
}


.user-info{
    display: flex;
    flex-direction: column; 
    justify-content: center; 
    align-items: center; 
    .name-tag{
        margin: -3px 0 0;
    }
    .user-avatar{
        border: 1px solid rgba(0, 0, 0, 0.6);
        // box-shadow: 0px 0px 0px 6px rgba(0, 0, 0, 0.6) inset; 
    }
    .msg {
        white-space: nowrap;
        color: #16171B;
        font-weight: 500;
        font-size: 10px;
        padding: 2px;
        text-align: center;
        min-width: 34px;
        height: 14px;
        line-height: 10px;
        border-radius: 33px;
        background: #02B780;
        position: absolute;
        top: -21px;
        left: 50%;
        transform: translateX(-50%);
        padding: 2px 4px;
        .tri-down {
            width: 0;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid #02B780;
            position: absolute;
            bottom: -6px;
            left: 50%;
            transform: translateX(-50%);
        }
        &-0 {
            background: #D9D9D9;
            .tri-down {
                border-top-color: #D9D9D9;
            }
        }
        &-1 {
            color: #fff;
            background: #F88045;
            .tri-down {
                border-top-color: #F88045;
            }
        }
        &-2 {
            color: #fff;
            background: #02B780;
            .tri-down {
                border-top-color: #02B780;
            }
        }
        &-3 {
            color: #fff;
            background: #3D57FF;
            .tri-down {
                border-top-color: #3D57FF;
            }
        }
        &-4 {
            color: #fff;
            background: #e73759;

            .tri-down {
                border-top-color: #e73759;
            }
        }
    }
    .settled-text {
        position: absolute;
        top: -24px;
        white-space: nowrap;
        font-weight: 500;
        color: #58EDBA;
    }
    .won {
        color: #f6df33;
    }
}

.clock-box {
    position: absolute;
    width: 35px;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    .clock {
        width: 35px;

    }
    .clock-num {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

/* 时钟原地左右倾斜晃动 */
@keyframes clock-shake {
    0%, 100% { transform: rotate(0deg); }
    25% { transform: rotate(5deg); }
    50% { transform: rotate(-5deg); }
    75% { transform: rotate(5deg); }
}
.clock-shake {
    animation: clock-shake 0.2s ease-in-out infinite;
    transform-origin: center center;
}

.cards-info{
    --gap: 6px;
    display: flex;
    flex-direction: column; 
    justify-content: center; 
    align-items: center; 
    margin-bottom: 5px;
    margin-left: var(--gap); 
    align-self: flex-end; 
    .cards-wrap{
        margin: 0 0 5px;
        position: relative; 
        .result-pics{
            position: absolute;
            z-index: 5;
            top: 0;
            left: 0%;
            right: 0%; 
            margin: 0 -5px; 
            transform: translateY(calc(-100% + 5px)); 
            img{
                width: 100%; 
                max-width: 100px;  
                margin: 0 auto; 
            }
        }
        .one-card{
            filter: drop(0px 0px 5px rgba(0, 0, 0, 0.5));
            & + .one-card{
                margin-left: -6px;
            }
        }
        .real-cards{
            position: absolute;
            top: 0;
            left: 0;
            // 启用 GPU 加速提示，优化动画性能
            backface-visibility: hidden;
            -webkit-font-smoothing: antialiased;
        }

        .status-tag  {
            min-width: 68px;
            height: 22px;
            padding: 1px;
            font-weight: 600;
            border-radius: 22px;
            font-size: 12px;
            z-index: 1;
            overflow: hidden;
            position: absolute;
            bottom: 10px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .tag-other {
            cursor: default;
            min-width: 40px;
            font-size: 10px;
            height: 18px;
            color: rgb(253, 217, 53);
            font-weight: normal;
        }
        .view-btn {
            background: #00000099;
            width: 117px;
            height: 42px;
            border-radius: 6.87px;
            font-family: HYZhengYuan;
            font-weight: 500;
            font-style: 65W;
            font-size: 25.18px;
            line-height: 11.83px;
            letter-spacing: 10%;
            text-align: center;
            vertical-align: middle;
        }
    }
}


.at-right {
    flex-flow: row-reverse;
    .cards-info{
        margin-left: 0; 
        margin-right: var(--gap); 
    }
}

.pking{
    .user-info{
        z-index: 3; // 正在 pk 的玩家需要抬高 
    }
}

.user-self{
    .cards-info{
        margin-left: 6px;
        align-self: center;  
        .one-card{
            &+.one-card {
                    margin-left: 8px;
                }
        }
    }
}

.now-pking,
.select-user{
    .user-info{
        z-index: 4; 
    }
    .cards-info {
        z-index: 3;
    }
}
.pointer-img {
    position: absolute;
    width: 25px;
    z-index: 10;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    opacity: 0;
}

@keyframes pointerMove {
    0%, 100% {
        transform: translateY(-50%) translateY(0);
    }
    50% {
        transform: translateY(-50%) translateY(-10px);
    }
}
.select-user {
    .active {
        border: 2px solid #02B780;
        filter: drop-shadow(0px 0px 10px rgb(9, 136, 58));
        font-weight: bold;
        cursor: pointer;
        animation: breathing 1.2s infinite ease-in-out;
    }
    .pointer-img {
        opacity: 1;
        animation: pointerMove 1.2s ease-in-out infinite;
    }
}

.lose {
    filter: grayscale(100%);
}
// ↓ 动画 ----------------- 

.bounce-enter-active {
    animation: bounce-in 0.5s;
    // animation-delay: 0.5s;
}

.bounce-leave-active {
    // animation: bounce-in 0.5s reverse;
    animation: none; 
}

@keyframes bounce-in {
    0% {
        transform: scale(0) translateY(20px);
        opacity: 0;
    }
    50% {
        transform: scale(1.2) translateY(10px); 
        opacity: 0;
    }
    100% {
        transform: scale(1) translateY(0);
        opacity: 1;
    }
}

.moveup-enter-active {
    transition: transform 0.4s ease-out, opacity 0.4s ease-out;
}

.moveup-leave-active {
    transition: none;
}

.moveup-enter-from {
    opacity: 0;
    /* 所有玩家统一从庄家位置（上方中间）飞出，保证“都从庄家来” */
    transform: translate(0, -140px) scale(0.7) rotate(0deg);
}

.moveup-enter-to {
    opacity: 1;
    transform: translate(0, 0) scale(1) rotate(0deg);
}

/* 更强烈的闪烁动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
/* 呼吸效果 */
@keyframes breathing {
    0% {
        border-color: #02B780;
        box-shadow: 0 0 2px rgba(2, 183, 128, 0.4);
    }
    50% {
        border-color: #00ffcc;
        box-shadow: 0 0 6px rgba(0, 255, 204, 0.8);
    }
    100% {
        border-color: #02B780;
        box-shadow: 0 0 2px rgba(2, 183, 128, 0.4);
    }
}
</style>

